import { ToolInventory, ToolOrder, ToolOrderCatalog } from '@bechtel/ht-types';
import { sumBy } from 'lodash';
import { useMemo } from 'react';

export const useToolOrderInventoryStats = (toolOrder: ToolOrder, toolOrderCatalogItem: ToolOrderCatalog) => {
  const toolOrderInventoryStats = useMemo(() => {
    const pickedQuantity = sumBy(
      toolOrder.toolOrderCatalogs?.find((item) => item.id === toolOrderCatalogItem.id)?.toolOrderInventories,
      'dispatchQuantity'
    );

    const availableCount =
      toolOrder.availableToolInventories?.find(
        (inventories) => inventories.toolCatalogId === toolOrderCatalogItem?.toolCatalog?.id
      )?.quantityOnHand || 0;

    return {
      pickedQuantity,
      availableCount,
    };
  }, [toolOrderCatalogItem, toolOrder]);

  return toolOrderInventoryStats;
};

export const useToolOrderInventoryCount = (
  toolOrderInventoryItems: { toolInventory: ToolInventory; dispatchQuantity: any }[]
) => {
  const toolOrderCatalogStats = useMemo(() => {
    const toolTypesTotal = toolOrderInventoryItems?.reduce((acc, item) => {
      const quantity = item.dispatchQuantity;
      const toolTypeName = item.toolInventory?.toolCatalog?.toolCategory?.toolType?.name;
      if (toolTypeName) {
        if (!acc[toolTypeName]) {
          acc[toolTypeName] = {
            quantity,
            toolTypeName,
          };
        } else {
          acc[toolTypeName].quantity += quantity;
        }
      }
      return acc;
    }, {});

    const total = toolOrderInventoryItems?.reduce((acc, item) => acc + item.dispatchQuantity, 0);

    return [total, toolTypesTotal];
  }, [toolOrderInventoryItems]);

  return toolOrderCatalogStats;
};
